// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { searchHistoryStyles } from "@vanmeter/Overrides/Widgets/Header/SearchHistory";
import { styledScrollbar } from "@vanmeter/XDL/Utilities";
import Clock from "@insite/mobius/Icons/Clock";
import { css } from "styled-components";
import { fontConfig } from "@vanmeter/XDL/constants";
import { headerText } from "@vanmeter/App/SharedStyles/AutoCompleteSharedStyles";

searchHistoryStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
        padding: 12px;
        ${styledScrollbar()}
    `,
};

searchHistoryStyles.headerText = headerText;

searchHistoryStyles.clearLink = {
    typographyProps: {
        ...fontConfig.xSmallSingleLine
    },
};

searchHistoryStyles.topWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `,
};

searchHistoryStyles.icon = {
    src: Clock,
    size: 12,
    color: "primary",
    css: css`
        margin-right: 6px;
    `,
};

searchHistoryStyles.link = {
    typographyProps: {
        ...fontConfig.xSmallSingleLine
    },
};

searchHistoryStyles.itemsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 12px;
    `,
};
